import { combineReducers } from 'redux';

import list from './list';
import selected from './selected';
import verification from './verification';
import updatePlanPromotionCode from './updatePlanPromotionCode';

export default combineReducers({
  list,
  selected,
  verification,
  updatePlanPromotionCode,
});
